(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/hooks/use-full-size-screen-game-resize.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/hooks/use-full-size-screen-game-resize.js');
"use strict";

const {
  useEffect,
  useCallback
} = React;
const PAY_FOOTER_BREAKPOINT = 720;
const GAME_MIN_HEIGHT = 650;
const useFullSizeScreenGameResize = ref => {
  const resizeGame = useCallback(() => {
    var _document$querySelect, _document$querySelect2, _document$querySelect3;
    const menuHeight = ((_document$querySelect = document.querySelector('.js-fixed-top-content')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getBoundingClientRect().height) || 0;
    const menuItemsHeight = ((_document$querySelect2 = document.querySelector('.js-items-menu-wrapper')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.getBoundingClientRect().height) || 0;
    let payFooterHeight = ((_document$querySelect3 = document.querySelector('#kex-pay-footer')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.getBoundingClientRect().height) || 0;
    if (window.innerHeight < PAY_FOOTER_BREAKPOINT) {
      payFooterHeight = -1; 
    }
    const height = window.innerHeight - payFooterHeight - menuItemsHeight - menuHeight;
    const width = document.body.clientWidth; 
    if (ref !== null && ref !== void 0 && ref.current) {
      ref.current.style.height = window.innerHeight > window.innerWidth ? "".concat(height, "px") : "".concat(Math.max(GAME_MIN_HEIGHT, height), "px");
      ref.current.style.width = "".concat(width, "px");
    }
  }, [ref]);
  useEffect(() => {
    const debounceResize = _.debounce(resizeGame, 50);
    window.addEventListener('resize', debounceResize);
    resizeGame();
    return () => {
      window.removeEventListener('resize', debounceResize);
    };
  }, [resizeGame]);
  return [resizeGame];
};
svs.kenoXpress.react.hooks.useFullSizeScreenGameResize = useFullSizeScreenGameResize;

 })(window);